import { useAppSelector } from 'reduxStore/store'
import EstablishmentStorage from 'storage/establishment'
import { IPatientVitalSignsResponse } from 'types/patient/types'

export const checkIsHDAByStorage = () => {
  const storage = EstablishmentStorage.currentEstablishment.get()

  if (!storage) return false

  return (
    JSON.parse(storage)['commercial_name']?.toLowerCase() == 'hospital de amor'
  )
}

export const useShowBannerHDA = () => {
  const establishmentName = useAppSelector(
    rState => rState.establishment.data?.commercial_name
  )

  return establishmentName?.toLowerCase() == 'hospital de amor'
}

export const useBannerData = (
  vitalSigns?: IPatientVitalSignsResponse,
  bannerCheck?: boolean
) => {
  const showBannerHDA = useShowBannerHDA()
  const effectiveBannerCheck = bannerCheck ?? showBannerHDA
  if (!effectiveBannerCheck || !vitalSigns) return []

  const {
    o2_saturation: o2Saturation,
    blood_pressure_systolic: bps,
    blood_pressure_diastolic: bpd,
    temperature_celsius: temperature,
    heart_rate_rest: heartRateRest
  } = vitalSigns

  const vsList: Array<string> = []

  if (heartRateRest && (heartRateRest < 60 || heartRateRest > 120)) {
    vsList.push(
      'Frequência Cardíaca em Repouso fora do intervalo entre 60 bpm à 120 bpm'
    )
  }
  if (o2Saturation && o2Saturation < 92) {
    vsList.push('Saturação de O2 abaixo de 92%')
  }
  if ((bps && bps < 90) || (bpd && bpd < 65)) {
    vsList.push(
      'Pressão Arterial Sistólica menor que 90 mmHg ou Diastólica menor que 65 mmHg'
    )
  }
  if (temperature && (temperature > 38 || temperature < 36)) {
    vsList.push('Temperatura Corporal fora do intervalo entre 36 ºC à 38 ºC')
  }

  return vsList
}

// Pure function version for use in sorting or non-hook contexts
export const getBannerDataPure = (
  vitalSigns?: IPatientVitalSignsResponse,
  bannerCheck?: boolean
) => {
  if (!bannerCheck || !vitalSigns) return []

  const {
    o2_saturation: o2Saturation,
    blood_pressure_systolic: bps,
    blood_pressure_diastolic: bpd,
    temperature_celsius: temperature,
    heart_rate_rest: heartRateRest
  } = vitalSigns

  const vsList: Array<string> = []

  if (heartRateRest && (heartRateRest < 60 || heartRateRest > 120)) {
    vsList.push(
      'Frequência Cardíaca em Repouso fora do intervalo entre 60 bpm à 120 bpm'
    )
  }
  if (o2Saturation && o2Saturation < 92) {
    vsList.push('Saturação de O2 abaixo de 92%')
  }
  if ((bps && bps < 90) || (bpd && bpd < 65)) {
    vsList.push(
      'Pressão Arterial Sistólica menor que 90 mmHg ou Diastólica menor que 65 mmHg'
    )
  }
  if (temperature && (temperature > 38 || temperature < 36)) {
    vsList.push('Temperatura Corporal fora do intervalo entre 36 ºC à 38 ºC')
  }

  return vsList
}

export const useVitalSignToPaint = (
  vitalSigns?: IPatientVitalSignsResponse
) => {
  const showBanner = useShowBannerHDA()
  if (!showBanner || !vitalSigns) return []
  const {
    o2_saturation: o2Saturation,
    blood_pressure_systolic: bps,
    blood_pressure_diastolic: bpd,
    temperature_celsius: temperature,
    heart_rate_rest: heartRateRest
  } = vitalSigns

  const vsKeyList: Array<string> = []

  if (heartRateRest && (heartRateRest < 60 || heartRateRest > 120)) {
    vsKeyList.push('heart_rate_rest')
  }
  if (o2Saturation && o2Saturation < 92) {
    vsKeyList.push('o2_saturation')
  }
  if ((bps && bps < 90) || (bpd && bpd < 65)) {
    vsKeyList.push('blood_pressure_systolic')
  }
  if (temperature && (temperature > 38 || temperature < 36)) {
    vsKeyList.push('temperature_celsius')
  }

  return vsKeyList
}
